

export const getPlatformColor = (platform: string) => {
  switch (platform) {
    case 'ebay':
    case 'ebay_packlink':
      return {
        textClass:'text-blue-700',
        bgClass:'bg-blue-700',
        textOnBgClass:'text-white'
      };
    case 'aliexpress':
      return {
        textClass:'text-red-500',
        bgClass:'bg-red-500',
        textOnBgClass:'text-white'
      };
    case 'leboncoin':
      return {
        textClass:'text-orange-700',
        bgClass:'bg-orange-700',
        textOnBgClass:'text-white'
      };
    case 'temu':
      return {
        textClass:'text-orange-600',
        bgClass:'bg-orange-600',
        textOnBgClass:'text-white'
      };
  }

  return {
    textClass:'',
    bgClass:'',
    textOnBgClass:''
  };
}
